<template>
    <div>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item" aria-current="page">
                        <a href="javascript:void(0)">Deviations</a>
                    </li>
                    <!-- <li class="breadcrumb-item active" aria-current="page">Deviations</li> -->
                </ol>
                <h4 class="main-title mb-0">Deviations</h4>
            </div>
             <router-link to="/completed_deviations" class="btn btn-primary"> Completed Deviations</router-link>
            <!-- <router-link v-can="'users.create'" to="/user/create" class="btn btn-primary" style="float: right;"><i
                        class="ri-list-check"></i> ADD USER</router-link> -->
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Deviations</h6>
                        <button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#remarkModal" v-if="selectedRows.length > 0">Update Deviations</button>
                    </div>
                    <div class="card-body">
                        <!-- <td>Department
                                <span>
                                    <i v-if="meta.keyword=='department_id' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                    <i v-else-if="meta.keyword=='department_id' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                    <i v-else class="fas fa-sort"></i>
                                </span>
                            </td> -->
                        <div class="row">
                            <div class="col-4">
                                <!-- <select class="form-control form-control-sm mb-2" v-model="meta.department_id" @change="search()">
                                    <option value="">Select Department</option>
                                    <option v-for="department, key in departments" :key="key" :value="department.department_id">{{ department.department_name }}</option>
                                </select> -->
                                  <search
                                    :class="{ 'is-invalid': errors.department_id }"
                                    :customClass="{ 'is-invalid': errors.department_id }"
                                    :initialize="meta.department_id"
                                    id="department_id"
                                    label="department_name"
                                    placeholder="Select Department"
                                    :data="departments"
                                    @input="department_id => meta.department_id = department_id"
                                    @selectsearch="search()"
                                >
                                </search>
                            </div>
                            <div class="col-8">
                                <input class="form-control  mb-2" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()" />
                            </div>
                        </div>

                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm text-nowrap table-striped table-bordered mb-0">
                                <thead>
                                    <tr style="background-color: #9b9b9b; color: white;">
                                        <th class="text-center"># <input type="checkbox" @change="toggleSelectAll($event)" :checked="allSelected" /></th>
                                        <th>
                                            Department
                                            <span>
                                                <i v-if="meta.keyword == 'department_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'department_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th>
                                            Asset
                                            <span>
                                                <i v-if="meta.keyword == 'asset_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'asset_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th>
                                            Asset Type
                                            <span>
                                                <i v-if="meta.keyword == 'asset_type_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'asset_type_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th>
                                            Check Date
                                            <span>
                                                <i v-if="meta.keyword == 'reference_date' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'reference_date' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('field_name')">
                                            Check
                                            <span>
                                                <i v-if="meta.keyword == 'field_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'field_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('lcl')">
                                            Lcl
                                            <span>
                                                <i v-if="meta.keyword == 'lcl' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'lcl' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('ucl')">
                                            Ucl
                                            <span>
                                                <i v-if="meta.keyword == 'ucl' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'ucl' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('default_value')">
                                            Default Value
                                            <span>
                                                <i v-if="meta.keyword == 'default_value' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'default_value' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>

                                        <th @click="sort('value')">
                                            Value
                                            <span>
                                                <i v-if="meta.keyword == 'value' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'value' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th v-can="'deviations.update'" class="text-center">Action</th>
                                        <!-- <th class="text-center" v-can="'users.delete'">Status</th>
                                                <th class="text-center" v-can="'users.update'">Actions</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="deviation, key in user_assets" :key="key">
                                        <td class="text-center">{{ meta.from + key }} <input type="checkbox" :value="deviation.user_asset_check_id" v-model="selectedRows" /></td>
                                        <td>{{ deviation.department?.department_name }}</td>
                                        <td>{{deviation?.asset?.asset_name}}</td>
                                        <td>{{deviation.asset_type?.asset_type_name}}</td>
                                        <td>{{ convertDateFormat(deviation.user_check?.reference_date)}}</td>
                                        <td>{{ deviation.check?.field_name}}</td>
                                        <td>{{ deviation?.lcl }}</td>
                                        <td>{{ deviation?.ucl }}</td>
                                        <td>{{ deviation.default_value }}</td>
                                        <td>{{ deviation.value }}</td>
                                        <td v-can="'deviations.update'">
                                            <button class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="update(deviation)"><i class="ri-add-line fs-18 lh-1"></i></button>
                                        </td>
                                        <!-- <td class="text-center" v-can="'users.delete'">
                                                <div class="form-switch" >
                                                    <input class="form-check-input"  type="checkbox" role="switch" :id="'user' + user.user_id" :checked="user.status" :value="user.status" @change="deleteUser(user)" />
                                                    <label class="custom-control-label" :for="'user' + user.user_id"></label>
                                                </div>
                                            </td>
                                            <td class="text-center" v-can="'users.update'">
                                                <a href="javascript:void(0)" class="text-success" v-if="user.status"
                                                    @click="editUser(user)"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                            </td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>
                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->

    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref="deviationModal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Upadte Deviation</h5>
                    <button type="button" id="close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div>
                        <label class="form-label">Remarks</label><span class="text-danger"> *</span>
                        <textarea rows="2" class="form-control" type="text" placeholder="Remarks" :class="{'is-invalid':errors.remarks}" v-model="user_check.remarks"></textarea>
                        <span v-if="errors.remarks" class="invalid-feedback">{{ errors.remarks[0] }}</span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" @click="updateDeviation">Update changes</button>
                </div>
            </div>
        </div>
    </div>
     <!-- remark modal -->
         <div class="modal fade" id="remarkModal" tabindex="-1" aria-labelledby="remarkModalLabel" aria-hidden="true" ref="remarkModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="remarkModalLabel">Update Deviations</h1>
        <button type="button" id="close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="clearRemark()"></button>
      </div>
      <div class="modal-body">
       <label class="form-label">Remark</label><span class="text-danger"> *</span>
        <textarea type="text" placeholder="Remark" class="form-control" v-model="meta.remark"></textarea>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="clearRemark()">Close</button>
        <button type="button" class="btn btn-primary" @click="submitRemark">Update </button>
      </div>
    </div>
  </div>
</div>
</div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
    import Search from "@/components/Search.vue";
    import moment from "moment";
    export default {
        components: {
            Pagination,Search
        },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "user_check_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                    department_id: "",
                },
                user_check: {
                    user_asset_check_id: "",
                    remarks: "",
                },
                user_assets: [],
                errors: [],
                departments: [],
                status: true,
                 selectedRows: [],
            };
        },
        // beforeRouteEnter(to, from, next) {
        //     next((vm) => {
        //         if(from.name != 'Users.Edit'){
        //             vm.$store.commit("setCurrentPage", vm.meta.page)
        //         }else{
        //             vm.meta.page = vm.$store.getters.current_page
        //         }
        //     });
    // },
          computed: {
            allSelected() {
                return this.user_assets.length > 0 &&
                    this.user_assets.every(item => this.selectedRows.includes(item.user_asset_check_id));
              }
            },
        mounted() {
            this.index();
            this.getDepartments();
        },

    methods: {
             toggleSelectAll(event) {
                if (event.target.checked) {
                    this.selectedRows = this.user_assets.map(item => item.user_asset_check_id);
                console.log("coiut", this.selectedRows)
                } else {
                this.selectedRows = [];
                }
        },
        submitRemark() {
    let vm = this;

    // Get full objects for selected rows
    let selectedItems = vm.user_assets.filter(item =>
        vm.selectedRows.includes(item.user_asset_check_id)
    );

    let payload = {
        remarks: vm.meta.remark,
        deviations: selectedItems, // include full objects
    };

    let loader = vm.$loading.show();
    vm.$store
        .dispatch("post", { uri: "bulkUpdateDeviation", data: payload })
        .then((response) => {
            loader.hide();
            vm.$store.dispatch("success", response.data.message);

            // Reset
            vm.selectedRows = [];
            vm.meta.remark = "";
          const modalInstance = bootstrap.Modal.getInstance(vm.$refs.remarkModal);
            modalInstance.hide();
            vm.index(); // Refresh list
        })
        .catch((error) => {
            loader.hide();
            vm.errors = error.response?.data?.errors || {};
            vm.$store.dispatch("error", error.response?.data?.message || "Failed");
        });
},

            clearRemark() {
                let vm = this;
            vm.meta.remark = "";
        },
            convertDateFormat(date) {
                let vm = this;
                return moment(date).format("DD-MM-YYYY");
            },
            index() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "deviationAssetChecks", data: vm.meta })
                    .then((response) => {
                        loader.hide();
                        vm.user_assets = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.from = response.data.meta.from;
                        const end = vm.meta.from + Number(vm.meta.per_page) - 1;
                        vm.meta.to = end > vm.meta.totalRows ? vm.meta.totalRows : end;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            update(deviation) {
                let vm = this;
                vm.user_check.user_asset_check_id = deviation.user_asset_check_id;
            },
            updateDeviation() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updateDeviation", data: vm.user_check })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);

                        vm.user_check = {};
                        vm.errors = {};
                        let modal = vm.$refs.deviationModal;
                        modal.style.display = "none";
                        document.getElementById("close").click();
                        vm.index();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getDepartments() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getDepartments" })
                    .then((response) => {
                        loader.hide();
                        vm.departments = response.data.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },

            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            onPerPageChange() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
        },
    };
</script>
